// used by saved search opt in
export const getShortBrandType = (brand) => {
    switch (brand) {
        case "immonet":
            return "imn";
        case "immowelt":
            return "iwt";
        case "seloger":
            return "sl";
        case "logicimmo":
            return "li";
        default:
            throw new Error(`Unknown brand type: ${brand}`);
    }
};
